import { FC, useCallback, useState, useEffect } from 'react';
import pauseConfirmModalClass from '../../assets/scss/PauseConfirmModal/PauseConfirmModal.module.scss';
import { PauseConfirmModalViewType } from '../../types/view/PauseConfirmModalViewType';
import { CommonModal } from '../CommonModal';
import { usePreventionData } from '../../hooks/use-master-data';
import { PreventionImages } from '../ModalItem/PreventionImages';
import { Setting } from '../../types/constant/PagesPropsType';
import { SubscriptionApiType } from '../../types/api/SubscriptionApiType';
import { postMessageGtag } from '../../utils/trackClick';

export const PauseConfirmModal: FC<{
  active: boolean;
  closeFunc: () => void;
  pauseConfirmModal: PauseConfirmModalViewType | null;
  clickSubmitFunc: () => void;
  onSwitchToRecommended?: () => void;
  loading: boolean;
  setting: Setting;
  subscription: SubscriptionApiType;
}> = ({
  active,
  closeFunc,
  pauseConfirmModal,
  clickSubmitFunc,
  onSwitchToRecommended,
  loading,
  setting,
  subscription,
}) => {
  const [showRecommendedSet, setShowRecommendedSet] = useState(false);

  const { preventionList } = usePreventionData('pause_prevention');

  const clickSubmitHandler = useCallback(() => {
    clickSubmitFunc();
    const eventName = pauseConfirmModal?.route === 'new' ? 'click_Pause' : 'click_Pause_oldSubsc';
    postMessageGtag(eventName, 'detailSettings');
  }, [clickSubmitFunc]);

  const clickSkipLinkHandler = useCallback(() => {
    pauseConfirmModal?.clickSkipLinkFunc();
    const eventName =
      pauseConfirmModal?.route === 'new'
        ? 'click_modal_open_skip_Pause'
        : 'click_modal_open_skip_Pause_oldSubsc';
    postMessageGtag(eventName, 'detailSettings');
  }, [pauseConfirmModal]);

  const clickCloseHandler = useCallback(() => {
    closeFunc();
    const eventName =
      pauseConfirmModal?.route === 'new'
        ? 'click_modal_close_Pause_cancel'
        : 'click_modal_close_Pause_cancel_oldSubsc';
    postMessageGtag(eventName, 'detailSettings');
    window.parent.postMessage({ action: 'fixedBtnShow' }, '*');
  }, [closeFunc]);

  // スキップモーダルがactiveでなくなった時にshowRecommendedSetをリセット
  useEffect(() => {
    if (!active) {
      setShowRecommendedSet(false);
    }
  }, [active]);

  const handleSwitchToRecommended = () => {
    // 停止モーダルを閉じる
    closeFunc();
    const eventName =
      pauseConfirmModal?.route === 'new' ? 'click_Switch_Pause' : 'click_Switch_Pause_oldSubsc';
    postMessageGtag(eventName, 'detailSettings');

    // 商品切り替えモーダルを開く
    if (onSwitchToRecommended) {
      onSwitchToRecommended();
    }
  };

  const clickExchangePoints = () => {
    const eventName =
      pauseConfirmModal?.route === 'new'
        ? 'click_PointExchange_Pause'
        : 'click_PointExchange_Pause_oldSubsc';
    postMessageGtag(eventName, 'detailSettings');
  };

  const onClickOutsideClose = () => {
    closeFunc();
    const eventName =
      pauseConfirmModal?.route === 'new'
        ? 'click_modal_close_Pause'
        : 'click_modal_close_Pause_oldSubsc';
    postMessageGtag(eventName, 'detailSettings');
  };

  if (!pauseConfirmModal) return <></>;

  const thanksmilePoints = Number(pauseConfirmModal.thanksmilePoints.replace(/,/g, ''));

  const content = (
    <>
      <div className={pauseConfirmModalClass.textContainer}>
        <div className={pauseConfirmModalClass.title}>定期オトク便を停止します</div>
        <div className={pauseConfirmModalClass.text}>
          再開は、マイアカウントから
          <br />
          簡単にできます。
          <br />
          2〜3週間の停止なら
          <span
            className={pauseConfirmModalClass.textLink}
            onClick={clickSkipLinkHandler}
          >
            スキップ
          </span>
          が便利
        </div>
        {thanksmilePoints >= 100 && (
          <div className={pauseConfirmModalClass.thanksmileContainer}>
            <span style={{ color: '#cc3044' }}>＼もっとオトクに！／</span>
            <br />
            ポイントをクーポンに交換しませんか？
            <br />
            <div className={pauseConfirmModalClass.pointContainer}>
              <span className={pauseConfirmModalClass.pointCircle}>P</span>
              <span style={{ fontWeight: 600 }}>
                所有ポイント：{pauseConfirmModal.thanksmilePoints}
              </span>
            </div>
            <a
              href="https://zenb.jp/pages/thanksmiles"
              target="_parent"
              className={pauseConfirmModalClass.exchangePointButton}
              onClick={clickExchangePoints}
            >
              ポイントを交換する
            </a>
          </div>
        )}
      </div>
      <div className={pauseConfirmModalClass.btnContainer}>
        <button
          className={pauseConfirmModalClass.btnPrimary}
          onClick={clickSubmitHandler}
          disabled={loading}
        >
          停止する
        </button>
      </div>
      <div className={pauseConfirmModalClass.closeContainer}>
        <span
          className={pauseConfirmModalClass.closeLink}
          onClick={clickCloseHandler}
        >
          閉じる
        </span>
      </div>
      <div className={pauseConfirmModalClass.divider}>
        <span>または</span>
      </div>
      <div className={pauseConfirmModalClass.leadText}>
        <button
          onClick={handleSwitchToRecommended}
          className={pauseConfirmModalClass.recommendedSetLink}
        >
          別の商品に切り替える
        </button>
      </div>
      {/* 一時停止対策 */}
      <PreventionImages
        preventionList={preventionList}
        route="pause"
      />
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={onClickOutsideClose}
    >
      {content}
    </CommonModal>
  );
};
